import _BaseAPIService from "./_BaseAPIService";

const apiService = _BaseAPIService.instance;
const FormService = {
  create: async (data) => {
    const response = await apiService.post("/studentinterestforms", data);
    return response.data;
  },
  createFranchise: async (data) => {
    const response = await apiService.post("/franchiseinquiry", data);
    return response.data;
  },
  eventForm:async (data) => {
    const response = await apiService.post("/eventsforms", data);
    return response.data;
  },
};

export default FormService;
